import "./App.css";
import HomePage from "./pages/HomePage";
import { Routes, Route } from "react-router-dom";
import DetailPage from "./pages/DetailPage";
import { UserProvider } from "./context/UserContext";
import LoginPage from "./pages/LoginPage";
import VisibleLayout from "./layouts/VisibleLayout";
import { ProtectedLayout } from "./layouts/ProtectedLayout";
import PageNotFound from "./pages/PageNotFound";
import StatistiquesPage from "./pages/StatistiquesPage";
import StockPage from "./pages/StockPage";
import StockDetailPage from "./pages/StockDetailPage";
import StockDiarDzairPage from "./pages/StockDiarDzairPage";

function App() {
  return (
    <UserProvider>
      <Routes>
        <Route path="/banque/" element={<VisibleLayout />}>
          <Route name="Login" path="login" element={<LoginPage />} />
        </Route>

        <Route path="/banque/" element={<ProtectedLayout />}>
          <Route name="Home" path="" element={<HomePage />} />
          <Route
            name="Home_pagination"
            path="page/:page"
            element={<HomePage />}
          />

          <Route
            name="Stock_dd"
            path="stock_dd/"
            element={<StockDiarDzairPage />}
          />
          <Route
            name="Stock_dd_pagination"
            path="stock_dd/page/:page"
            element={<StockDiarDzairPage />}
          />

          <Route name="Detail" path="detail/:hash" element={<DetailPage />} />

          <Route name="Stock" path="stock/" element={<StockPage />} />
          <Route
            name="Stock_pagination"
            path="stock/page/:page"
            element={<StockPage />}
          />

          <Route
            name="Stock-Detail"
            path="stock/detail/:hash"
            element={<StockDetailPage />}
          />

          <Route
            name="Statistique"
            path="statistiques/"
            element={<StatistiquesPage />}
          />
        </Route>

        <Route path="*" element={<PageNotFound />} />

        <Route path="/" element={<ProtectedLayout />}>
          <Route name="Initial" path="" element={<HomePage />} />
        </Route>
      </Routes>
    </UserProvider>
  );
}

export default App;
